import {useMemo} from "react";
import {useSelector} from "react-redux";
import {
    getSelectedAnimalForDocuments,
    makeGetAnimalsInGroup,
} from "../../../selectors/animalDocumentsSelectors";
import GroupAnimalList from "../GroupAnimalList";
import AnimalModificationList from "../animal-modification-list/AnimalModificationList";
import AnimalDocumentsComments from "../comments/AnimalDocumentsComments";
import FallGroupChart from "../fall/FallGroupChart";
import FatteningAnimalsGrid from "../fattening-animals/FatteningAnimalsGrid";
import FatteningProgress from "../fattening-progress/FatteningProgress";
import GraftingProgramGridCard from "../grafting/GraftingProgramGridCard";
import GroupGauges from "../group-gauges/GroupGauges";
import DeviceCharts from "../ideal-charts/DeviceCharts";
import EventCharts from "../ideal-charts/EventCharts";
import useAggregatedLoader from "../ideal-charts/useAggregatedLoader";
import useAnimalGroupInfo from "../ideal-charts/useAnimalGroupInfo";
import ReclassifyGrid from "../reclassify/ReclassifyGrid";
import RemovedCounter from "../removed/RemovedCounter";
import TransferGrid from "../transfer/TransferGrid";
import WeightingsGrid from "../weighting/WeightingGroupChart";

export default function GroupCard() {
    const group = useSelector(getSelectedAnimalForDocuments);

    const groupInfo = useAnimalGroupInfo();
    useAggregatedLoader("water", groupInfo.start, groupInfo.end);
    useAggregatedLoader("forage", groupInfo.start, groupInfo.end);
    useAggregatedLoader("temperature", groupInfo.start, groupInfo.end);

    const getAnimalsInGroup = useMemo(() => makeGetAnimalsInGroup(), []);

    const selectorProps = useMemo(() => ({getDeletedAnimals: true}), []);

    const animals = useSelector((state) =>
        getAnimalsInGroup(state, selectorProps)
    );

    const animalIds = useMemo(() => animals.map((o) => o.AnmID), [animals]);

    return (
        <>
            <FatteningProgress group={group} />
            <GroupGauges group={group} groupInfo={groupInfo} />
            <GroupAnimalList />
            <FatteningAnimalsGrid />
            <DeviceCharts groupInfo={groupInfo} />
            <FallGroupChart />
            <WeightingsGrid />
            <EventCharts />
            <TransferGrid isGroup getDeletedAnimals />
            <RemovedCounter isGroup getDeletedAnimals />
            {/* <SellGrid isGroup /> */}
            {/* <FallGrid isGroup /> */}
            <AnimalDocumentsComments />
            <ReclassifyGrid />
            <GraftingProgramGridCard isGroup />
            <AnimalModificationList animalIds={animalIds} />
        </>
    );
}
